module.exports = __webpack_public_path__ + "img/arrow_02_feature1_m.fd6062c4.svg";